import { db } from "$lib/firebase";
import { doc, getDoc } from "firebase/firestore";

export async function getShopManualDiscount(shopID: string): Promise<Discount> {
    const docRef = doc(db, "shops", shopID, "discount", "manualApply");

    const data = await getDoc(docRef);

    if (!data.exists() || !data.data() || !data.data().codes) {
        return {};
    }

    return data.data().codes;
}

export function applyDiscount(shopManualDiscount: Discount, manualCode: string, cart: Cart): void {
    if (manualCode === "") {
        return;
    }

    if (shopManualDiscount[manualCode]) {
        calculateDiscount(cart, shopManualDiscount[manualCode]);

    } else {
        throw new Error("No matching discount code found :(");
    }
}

function calculateDiscount(cart: Cart, discount: string): void {
    const discountParts = discount.split(" ");

    if (discountParts[0] === "PERCENTAGE") {
        const percentage = parseFloat(discountParts[1]);

        if (discountParts[3] === "ALL") {
            for (const displayDish of cart) {
                const dish = displayDish.dish;

                dish.discountAmount = Math.round((dish.price) * percentage) / 100;

                for (const option of dish.options) {
                    option.discountAmount = Math.round((option.price) * percentage) / 100;
                }
            }
        }
    } else if (discountParts[0] === "SETTOTAL") {
        const total = parseFloat(discountParts[1]);

        for (const displayDish of cart) {
            const dish = displayDish.dish;

            dish.price = 0;
            dish.discountAmount = 0;

            for (const option of dish.options) {
                option.price = 0;
                option.discountAmount = 0;
            }
        }

        cart[0].dish.price = Math.round(total / cart[0].quantity * 100) / 100;

        if (cart[0].dish.price * cart[0].quantity !== total) {
            cart[0].dish.price += 0.01;
        }
    }
}


export function calculateTotalDiscount(cart: Cart): number {
    let totalDiscount = 0;

    for (const displayDish of cart) {
        const dish = displayDish.dish;

        let aDiscount = dish.discountAmount;

        for (let i=0; i < dish.options.length; i++) {
            if (dish.selectedOptions[i]) {
                aDiscount += dish.options[i].discountAmount ?? 0;
            }
        }

        totalDiscount += aDiscount * displayDish.quantity;
    }

    // console.log(totalDiscount);
    // console.log(cart)
    return Math.round(totalDiscount * 100) / 100;
}